export default "__VITE_ASSET__Ci2nCIKf__"